/**
 * Çoklu GTFS feed registry — paylaşılan yardımcılar / sabitler.
 */

export const ANALYSIS_TABLE_NAMES = [
  'stops',
  'routes',
  'trips',
  'stop_times',
  'shapes',
  'calendar',
  'calendar_dates',
  'agency',
]

export function createLocalFeedId() {
  return `f_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
}

export function defaultFeedStats() {
  return {
    totalStops: 0,
    totalRoutes: 0,
    totalTrips: 0,
  }
}

export function defaultFeedTableCounts() {
  return {
    agency: 0,
    routes: 0,
    stops: 0,
    trips: 0,
    stop_times: 0,
    calendar: 0,
    calendar_dates: 0,
    shapes: 0,
    feed_info: 0,
  }
}

/**
 * @param {Partial<{
 *   localId: string
 *   dbId: number|null
 *   name: string
 *   source: 'upload'|'scenario'
 *   fileName: string
 *   includeInAnalysis: boolean
 *   stats: object
 *   tableCounts: object
 *   zipFile: File|Blob|null
 *   analysisTables: object|null
 *   analysisHydrated: boolean
 *   senaryoId: number|null
 *   gunTipi: string|null
 *   agencyName: string|null
 * }>} partial
 */
export function createFeedEntry(partial = {}) {
  return {
    localId: partial.localId || createLocalFeedId(),
    dbId: partial.dbId ?? null,
    name: partial.name || partial.fileName || 'GTFS Feed',
    source: partial.source || 'upload',
    fileName: partial.fileName || '',
    includeInAnalysis:
      partial.includeInAnalysis !== undefined ? partial.includeInAnalysis : true,
    stats: { ...defaultFeedStats(), ...(partial.stats || {}) },
    tableCounts: {
      ...defaultFeedTableCounts(),
      ...(partial.tableCounts || {}),
    },
    zipFile: partial.zipFile ?? null,
    analysisTables: partial.analysisTables ?? null,
    analysisHydrated: Boolean(partial.analysisHydrated),
    senaryoId: partial.senaryoId ?? null,
    gunTipi: partial.gunTipi ?? null,
    agencyName: partial.agencyName ?? null,
  }
}
